import './orden_compra.css'
export { default as Listado } from "./Listado";
export { default as Crear } from "./Crear"
export { default as TipoPago } from "./Crear/TipoPago"
export { default as DetalleOC } from "./Detalle"